import React from "react";
import {Modal, Timeline} from "antd";
import {IAssetHistoryData} from "../asset-category/type/asset-category.types";
import EmptyData from "../../common/empty-data/empty-data";
import {HistoryOutlined} from "@ant-design/icons";
import EmployeeAvatar from "../../employee/avatar/employee-avatar";
import {formatEnum} from "../../../utility/utility";
import Locale from "../../../core/locale/locale";
import dayjs from "dayjs";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IAssetHistoryModal {
    assetHistoryModal: boolean,
    handleAssetHistoryModalClose: () => void;
    assetHistory: IAssetHistoryData[],
    loading: boolean
}

const AssetHistoryModal = (props: IAssetHistoryModal) => {
    const firstItem = props.assetHistory?.[0];

    return (
        <Modal
            title={"Asset History"}
            open={props.assetHistoryModal}
            onCancel={props.handleAssetHistoryModalClose}
            className={'hrms-app asset-history-modal'}
            footer={<></>}
        >
            <LoadingSkeleton loading={props.loading}>
                <div>
                    {firstItem && (
                        <div className={'asset-details-section'}>
                            <div className={'asset-details'}>
                                <span> Asset: </span>
                                <strong>{firstItem.asset.assetCode}</strong>
                            </div>
                            <div className={'asset-details'}>
                                <span>Brand: </span>
                                <strong>{firstItem.asset.brandName}</strong>
                            </div>
                            <div className={'asset-details'}>
                                <span>Category:</span>
                                <strong>{firstItem.assetCategory.name}</strong>
                            </div>
                        </div>
                    )}

                    <div className={'asset-card-section'}>
                        {props.assetHistory.length > 0 ? (
                                <Timeline
                                    mode="left"
                                    items={props.assetHistory.map((item: IAssetHistoryData) => ({
                                        children: (
                                            <div className="record-card">
                                                <div className="render-top">
                                                    <div className="employee-section">
                                                        <EmployeeAvatar
                                                            name={{
                                                                firstName: item.employeeProfile.name.firstName,
                                                                lastName: item.employeeProfile.name.lastName
                                                            }}
                                                            thumbnailId={item.employeeProfile.profileThumbnailId}
                                                            size={30}
                                                        />
                                                        <div className="employee-name">
                                                            {item.employeeProfile.name.firstName}{" "}
                                                            {item.employeeProfile.name.middleName}{" "}
                                                            {item.employeeProfile.name.lastName}
                                                        </div>
                                                    </div>

                                                    <div className={`status-section ${item.status}`}>
                                                        {formatEnum(item.status)}
                                                    </div>
                                                </div>

                                                <div className="record-grid">
                                                    <div>
                                                        <div className="grid-label">Assigned Date</div>
                                                        <div className="grid-value">
                                                            {item.assignedDate
                                                                ? dayjs(item.assignedDate).format(Locale.displayDate)
                                                                : "—"}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div className="grid-label">Expected Return</div>
                                                        <div className="grid-value">
                                                            {item.expectedReturnDate
                                                                ? dayjs(item.expectedReturnDate).format(Locale.displayDate)
                                                                : "—"}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div className="grid-label">Returned Date</div>
                                                        <div className="grid-value">
                                                            {item.returnedDate
                                                                ? dayjs(item.returnedDate).format(Locale.displayDate)
                                                                : "—"}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div className="grid-label">Returnable</div>
                                                        <div className="grid-value">
                                                            {item.asset.isReturnable ? "Yes" : "No"}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <div className="grid-label">Assigned By</div>
                                                        <div className="grid-value">
                                                            {item.assignedBy || "—"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }))}
                                />)
                            : (
                                <EmptyData
                                    icon={<HistoryOutlined className={'asset-history-empty-icon'}/>}
                                    title={"No Activity Yet"}
                                    subtitle={"This asset hasn’t been assigned to anyone yet!"}
                                />
                            )}
                    </div>
                </div>
            </LoadingSkeleton>

        </Modal>
    );
};
export default AssetHistoryModal;
